import styled from "styled-components";

export const ListContainer = styled.div`
  display: flex;
`;
export const ListItemHead = styled.div`
  font-weight: bold;
  display: flex;
  margin: 0;
  color: #1381c5;
  padding: 0.5em 1em;
  margin-bottom: 0.5em;
  border-bottom: 1px solid white;
  text-transform: uppercase;
  &:first-child {
    margin-top: 0;
  }
`;
export const ListItem = styled.div`
  display: flex;
  padding: 0.5em 1em;
  &.between {
    justify-content: space-between;
  }
  svg {
    margin-top: 3px;
    margin-right: 10px;
  }
  &.red {
    color: red;
  }
`;
export const ListItemBold = styled.div`
  display: flex;
  font-weight: 600;
  padding: 0.5em 1em;
  svg {
    margin-right: 10px;
  }
`;

export const ListItemQuarter = styled.div`
  display: flex;
  flex: 1 1 25%;
  span {
    margin-left: 10px;
    cursor: pointer;
  }
  &.paid {
    color: green;
  }
  &.canceled {
    color: red;
  }
  &.open {
    color: yellow;
  }
  @media screen and (max-width: 768px) {
    &.hm {
      display: none;
    }
  }
`;
export const ToolTipContainer = styled.span`
  position: relative;
`;
export const LanguageContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.bg?? '#f5f6f6'};
  border-radius: 4px;
  padding: 5px;
  gap: 5px;
  position: relative;
  width: 100%;
  &.login{
    width: auto;
    padding: 0;
    // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 8px;
    margin-top: 10px;
  }
  &.channel {
    margin-top: 0px;
  }
`;
export const LanguageOptionContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 1001;
  min-width: 90px;
  &.login{
    width: 100%;
    // top: 50px;
    padding: 5px 0 0 0;
  }
`;
export const LanguageOption = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.bg?? '#ffffff'};
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 4px;
  padding: 10px 0;
  gap: 5px;
  max-height: 150px;
  overflow-y: auto;

`;
export const LanguageOptionValue = styled.div`
  padding: 5px 15px;
  cursor: pointer;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  &:hover {
    background-color: #f5f6f6;
  }
  &.active{
    color: #000000;
  }
  &.login{
    font-size: 14px;
    justify-content: left;
  }
`;
export const ToolTip = styled.div`
  position: absolute;
  top: 0;
  left: 19px;
  background-color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  margin-bottom: 10px;
  cursor: initial;
  &.language {
    top: 27px;
    left: -80px;
    font-size: 18px;
    @media screen and (max-width: 768px) {
      font-size: 15px;
    }
  }
  &.actions {
    top: 50px;
    left: auto;
    right: 0;
    z-index: 1000;
    font-size: 18px;
    padding: 0px;
    @media screen and (max-width: 768px) {
      font-size: 15px;
    }
  }
  &.hide {
    display: none;
  }
`;
